"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const inputs_1 = require("../../../../../inputs");
const AddressDialog = () => {
    return ((0, jsx_runtime_1.jsx)(ui_kit_1.FormGrid, { columns: [1], containerProps: { sx: theme => ({ marginBottom: theme.spacing(theme.tokens.spacing.xl) }) }, children: (0, jsx_runtime_1.jsx)(inputs_1.AddressInput, {}) }));
};
exports.AddressDialog = AddressDialog;
//# sourceMappingURL=index.js.map